/** OAuth / email auth callback URL for the current environment. */
export function getOAuthCallbackUrl(): string {
	const base =
		process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, "") ||
		(typeof window !== "undefined" ? window.location.origin : "")

	return `${base}/auth/callback`
}
